export const groups = [
        {
            id: 1,
            name: "Liturgiczna Służba Ołtarza",
            description:
                "Liturgiczna Służba Ołtarza przy parafii św. Urszuli w Częstochowie od lat gromadzi chłopców i młodzież pragnących służyć Bogu i wspólnocie podczas sprawowania liturgii. Ministranci i lektorzy aktywnie uczestniczą w życiu parafii – posługują podczas Mszy Świętych, nabożeństw i uroczystości, a także biorą udział w spotkaniach formacyjnych, wyjazdach integracyjnych i zawodach sportowych. Tradycjami wspólnoty są wspólne kolędowanie, ogniska integracyjne oraz udział w pielgrzymce na Jasną Górę. W duchu służby, modlitwy i przyjaźni młodzi członkowie LSO uczą się odpowiedzialności, współpracy i radości z bycia blisko Chrystusa.",
            meeting: "Sobota, godz. 9:00",
            leader: "Krzysztof Wrzosek",
            leaderName: "Prezes ",
            image: "./assets/podium.png",
            source: "Ikona autorstwa Anditii Creative",
            link: "https://pl.freepik.com/ikona/komunikacja_14544139#fromView=search&page=1&position=1&uuid=955bb325-a9c7-49cd-a311-2643d2646ea0"
        },
        {
            id: 2,
            name: "Spotkania Katechizmowe",
            description:
                "Spotkania katechizmowe są okazją do zgłębiania nauki zawartej w Katechizmie Kościoła Katolickiego oraz odkrywania piękna teologii. Wspólnie czytamy paragrafy Katechizmu, dzielimy się refleksjami i omawiamy je w kontekście codziennego życia. Prowadzący wyjaśnia teologiczne znaczenie poruszanych zagadnień. Jest to czas nie tylko nauki, ale także duchowego rozwoju i budowania wspólnoty. Spotkania sprzyjają pogłębianiu wiary, wzajemnemu wsparciu oraz wymianie doświadczeń religijnych.",
            meeting: "Pierwszy i trzeci poniedziałek miesiąca, godz. 19:00",
            leader: "ks. dr Mikołaj Węgrzyn",
            leaderName: "Prowadzący ",
            image: "./assets/bible_17875639.png",
            source: "freepik"
        },
        {
            id: 3,
            name: "Spotkania Młodzieży",
            description:
                "",
            meeting: "Pierwszy piątek miesiąca, godz. 19:00",
            leader: "",
            leaderName: "Koordynator ",
            image: "./assets/meeting.png",
            source: "freepik"
        },
        {
            id: 4,
            name: "Schola Parafialna",
            description:`
            Schola liturgiczna przy naszej parafii działa z radością już od 2006 roku. Choć przez lata skład się zmieniał, jedno pozostaje niezmienne – pasja i miłość do śpiewu na chwałę Boga.

            Na początku była to niewielka grupa młodzieży. Śpiewaliśmy w dwugłosie, przy akompaniamencie gitary, skrzypiec i bębenka. Z czasem zrodziło się pragnienie, by rozwijać się dalej – tak powstała schola czterogłosowa, do której dołączyli nowi członkowie, również dorośli.
            Spotykamy się regularnie na próbach, zwłaszcza w okresach przygotowań do świąt i uroczystości liturgicznych.
            Uczestniczymy również w warsztatach muzyki liturgicznej, które pomagają nam doskonalić technikę śpiewu i pogłębiać jego duchowy wymiar.
            `,
            meeting: "Piątek, godz. 19:00",
            leader: "Grażyna Mulica",
            leaderName: "Prowadzący ",
            image: "./assets/flute.png",
            source: "freepik"
        },
        {
            id: 5,
            name: "Żywy Różaniec",
            description:
                "Wspólnota żywego różańca powstała wraz z parafią. Jej celem jest codzienna modlitwa różańcowa w intencjach parafii. Obecnie wspólnota liczy siedem róż, czyli łącznie 140 członków. Każdy z nich zobowiązuje się do codziennego odmawiania jednej dziesiątki różańca, rozważając przydzieloną tajemnicę. Do różańca mogą należeć wszyscy, od dzieci do bardzo dorosłych. Jest tu miejsce dla każdego, kto chce we wspólnocie modlić się wraz z Maryją do Boga. Tych, którzy chcą należeć do różańca, zapraszamy w każdą pierwszą niedzielę miesiąca o godzinie 9:00 na Mszę Świątą. Później następuje wymiana tajemnic, zawsze można przyjść z nami się pomodlić.",
            meeting: "Pierwsza niedziela miesiąca - Msza Święta o godzinie 9:00",
            leader: "Elżbieta Sokołowska",
            leaderName: "Koordynator ",
            image: "./assets/rosary.png",
            source: "freepik"
        },
        {
            id: 6,
            name: "Wspólnota Dzieła Intronizacji Najświętszego Serca Pana Jezusa",
            description:
                "W naszej parafii Wspólnota Dzieła Intronizacji Najświętszego Serca Pana Jezusa istnieje od 26 września 1999 roku. Ideą ruchu jest wynagradzanie Sercu Bożemu za grzechy swoje, rodziny, narodu i całego świata oraz przygotowanie rodzin, miast do intronizacji Najświętszego Seraca Pana Jezusa w wymiarze państwa. Głównym zobowiązaniem Dzieła Intronizacji jest cotygodniowa wspólnotowa adoracja wynagradzająca Bożemu Sercu. Warunkiem koniecznym, aby zostać członkiem wspólnoty jest dokonanie poświęcenia się Sercu Jezusowemu i uznanie Jezusa Królem swego życia.",
            meeting: "Środa, godz. 19:00",
            leader: "Teresa Nowak",
            leaderName: "Koordynator ",
            image: "./assets/church_15205025.png",
            source: "freepik"
        },
        {
            id: 7,
            name: "Apostolat Margaretka",
            description:
                "Apostolat Margaretka w naszej parafii istnieje od sierpnia 2021 roku. Jest to ruch modlitewny, który obejmuje kapłanów codzienną modlitwą różańcową. Obecnie składa się z 6 Margaretek. Wspólnota akcentuje potrzebę modlitwy za kapłanów, która w sposób duchowy pomaga im jak najlepiej sprawować posługę duszpasterską i wiernie trwać w swoim powołaniu.",
            meeting: "Środa, godz. 19:00",
            leader: "Krystyna Kozińska",
            leaderName: "Koordynator ",
            image: "./assets/bow_9118119.png",
            source: "freepik"
        },
    ];
